import { ThreePointsActionType } from 'enums';
import { ThreePointsType } from 'state';

export const setThreePoints = (threePoints: ThreePointsType[]) =>
  ({ type: ThreePointsActionType.SET_THREE_POINTS, threePoints } as const);
